import React from "react";
import { Card, Button, Form } from "react-bootstrap";
import moment from "moment";

const ProjectRemarksTab = ({
  // Data
  remarks,
  remarksLoading,

  // Edit states
  editingRemarkId,
  editingRemarkText,
  updatingRemark,

  // Input states
  remarkText,
  addingRemark,

  // Permissions
  hasEditPermission,

  // Handlers
  setRemarkText,
  handleAddRemark,
  startEditRemark,
  cancelEditRemark,
  setEditingRemarkText,
  handleUpdateRemark,
}) => {
  return (
    <div className="project-view-fade-in">
      <Card>
        <Card.Body>
          <h5 className="mb-3">Project Remarks</h5>

          {/* Add Remark - Only for users with edit permission */}
          {hasEditPermission() && (
            <div className="d-flex mb-3">
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="Add a remark..."
                value={remarkText}
                onChange={(e) => setRemarkText(e.target.value)}
              />
              <Button
                variant="primary"
                className="ms-2"
                onClick={handleAddRemark}
                disabled={addingRemark}
              >
                {addingRemark ? "Adding..." : "Add"}
              </Button>
            </div>
          )}

          {/* Remarks List */}
          {remarksLoading ? (
            <p>Loading remarks...</p>
          ) : remarks.length === 0 ? (
            <p className="text-muted">No remarks yet.</p>
          ) : (
            <div>
              {(Array.isArray(remarks) ? remarks : []).map((remark, index) => (
                <Card key={index} className="mb-2">
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <strong>{remark.createdBy}</strong>
                        <small className="text-muted ms-2">
                          {moment(
                            remark.createdOnDate.split("T")[0] +
                              " " +
                              remark.createdOnTime,
                          ).format("DD MMM YYYY HH:mm")}
                        </small>
                      </div>
                      {/* Edit button - Only show for users with edit permission */}
                      {hasEditPermission() &&
                        editingRemarkId !== remark.guid && (
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => startEditRemark(remark)}
                            title="Edit remark"
                          >
                            Edit
                          </Button>
                        )}
                    </div>

                    {/* Edit Mode */}
                    {editingRemarkId === remark.guid ? (
                      <div className="mt-2">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={editingRemarkText}
                          onChange={(e) => setEditingRemarkText(e.target.value)}
                          className="mb-2"
                        />
                        <div className="d-flex gap-2">
                          <Button
                            variant="success"
                            size="sm"
                            onClick={() =>
                              handleUpdateRemark(remark.guid, editingRemarkText)
                            }
                            disabled={updatingRemark}
                          >
                            {updatingRemark ? "Saving..." : "Save"}
                          </Button>
                          <Button
                            variant="secondary"
                            size="sm"
                            onClick={cancelEditRemark}
                            disabled={updatingRemark}
                          >
                            Cancel
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div className="mt-2">{remark.remarks}</div>
                    )}
                  </Card.Body>
                </Card>
              ))}
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ProjectRemarksTab;
